import { Jersey } from '@/ui/components';

import StatisticsNumber from '../StatisticsNumber';

interface TeamShotsJerseyColumnProps {
  /** Displayed shots-per-game value for this side. */
  shotsPerGame: number;
  /** Jersey image URL (same contract as `Jersey` `jerseySrc`). */
  jerseySrc: string;
  /** When true, column layout is mirrored for the away side. */
  isAway?: boolean;
}

export default function TeamShotsJerseyColumn({
  shotsPerGame,
  jerseySrc,
  isAway = false,
}: TeamShotsJerseyColumnProps) {
  return (
    <div
      className={`flex w-[80px] shrink-0 items-center justify-start gap-1${isAway ? ' flex-row-reverse' : ''}`}
    >
      <Jersey jerseySrc={jerseySrc} size={40} />
      <div className="flex min-h-px min-w-0 flex-1 flex-col gap-1">
        <StatisticsNumber>{shotsPerGame}</StatisticsNumber>
      </div>
    </div>
  );
}
